import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Youtube } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export default function Footer() {
  const { t, content } = useLang();
  const contact = content?.contact || {};
  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground grain">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/gybc-logo-cream.png" alt="Got Your Back Club" className="h-16 w-auto mb-5" />
          <p className="text-primary-foreground/70 max-w-sm leading-relaxed">
            {t("Where women lift women. A community built on showing up, lifting loud, and never gatekeeping.",
               "Où les femmes élèvent les femmes. Une communauté fondée sur la présence, la célébration et le partage.")}
          </p>
          <div className="flex gap-4 mt-6">
            {[Linkedin, Instagram, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-secondary hover:border-secondary transition-colors">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-secondary font-semibold mb-5">{t("Explore", "Explorer")}</p>
          <ul className="space-y-3 text-primary-foreground/80">
            <li><Link to="/about" className="hover:text-secondary">{t("About", "À propos")}</Link></li>
            <li><Link to="/events" className="hover:text-secondary">{t("Events", "Événements")}</Link></li>
            <li><Link to="/community" className="hover:text-secondary">{t("Community", "Communauté")}</Link></li>
            <li><Link to="/media" className="hover:text-secondary">{t("Media", "Médias")}</Link></li>
            <li><Link to="/contact" className="hover:text-secondary">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.25em] text-secondary font-semibold mb-5">{t("Get in touch", "Nous joindre")}</p>
          <ul className="space-y-3 text-primary-foreground/80">
            <li>{contact.email || "hello@gybclub.ca"}</li>
            <li>{contact.phone || "(416) 555-0192"}</li>
            <li>{contact.address || "King West, Toronto ON, Canada"}</li>
            <li><Link to="/join" className="text-secondary font-semibold hover:underline">{t("Become a member", "Devenir membre")} →</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/15">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row justify-between gap-2 text-sm text-primary-foreground/50">
          <span>© {new Date().getFullYear()} Got Your Back Club. {t("All rights reserved.", "Tous droits réservés.")}</span>
          <span>{t("Made with heart in Toronto.", "Fait avec cœur à Toronto.")}</span>
        </div>
      </div>
    </footer>
  );
}
